import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IVendorPayoffInformationData } from '../../../types/vendorDashboard/IVendorPayoffInformation';
import { TOrderPayload } from 'types/order/vendorDashboard/TOrderPayload';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { vendorPayoffInitialState } from './interfaces';

export const vendorPayoffReducer = createSlice({
  name: 'vendorPayoffInformation',
  initialState: vendorPayoffInitialState,
  reducers: {
    setVendorPayoffDataAction: (state, action: PayloadAction<TOrderPayload<IVendorPayoffInformationData>>) => {
      state.payoff[action.payload.orderId] = action.payload.value;
    },
    setVendorPayoffFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.payoffFetchStatus = action.payload;
    },
    setVendorPayoffErrorAction: (state, action: PayloadAction<string | undefined>) => {
      state.payoffError = action.payload;
    },
    setUpdateVendorPayoffFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.updatePayoffFetchStatus = action.payload;
    },
    setUpdateVendorPayoffErrorAction: (state, action: PayloadAction<string | undefined>) => {
      state.updatePayoffError = action.payload;
    },
    setSendToSpruceFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.sentToSpruceFetchStatus = action.payload;
    },
    setSendToSpruceErrorAction: (state, action: PayloadAction<string | undefined>) => {
      state.sentToSpruceError = action.payload;
    },
  },
});
export const {
  setVendorPayoffDataAction,
  setVendorPayoffFetchStatusAction,
  setVendorPayoffErrorAction,
  setSendToSpruceErrorAction,
  setSendToSpruceFetchStatusAction,
  setUpdateVendorPayoffErrorAction,
  setUpdateVendorPayoffFetchStatusAction,
} = vendorPayoffReducer.actions;
